export const stagesInitialState = {
	entities: {},
};



// WEBPACK FOOTER //
// ./src/redux/stages/stages.initialState.js